module.exports = __webpack_public_path__ + "static/media/payslipNoRecord.102b1935.svg";